var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSegmentationPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6867 5.18016C11.64 5.1735 11.5934 5.1735 11.5467 5.18016C10.5134 5.14683 9.69336 4.30016 9.69336 3.26016C9.69336 2.20016 10.5534 1.3335 11.62 1.3335C12.68 1.3335 13.5467 2.1935 13.5467 3.26016C13.54 4.30016 12.72 5.14683 11.6867 5.18016Z",
    fill: "#A4A7AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8602 9.79978C13.1136 10.2998 12.0669 10.4864 11.1002 10.3598C11.3536 9.81311 11.4869 9.20645 11.4936 8.56645C11.4936 7.89978 11.3469 7.26645 11.0669 6.71311C12.0536 6.57978 13.1002 6.76645 13.8536 7.26645C14.9069 7.95978 14.9069 9.09978 13.8602 9.79978Z",
    fill: "#A4A7AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29327 5.18016C4.33994 5.1735 4.38661 5.1735 4.43327 5.18016C5.46661 5.14683 6.28661 4.30016 6.28661 3.26016C6.28661 2.1935 5.42661 1.3335 4.35994 1.3335C3.29994 1.3335 2.43994 2.1935 2.43994 3.26016C2.43994 4.30016 3.25994 5.14683 4.29327 5.18016Z",
    fill: "#A4A7AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36675 8.56657C4.36675 9.21324 4.50675 9.82657 4.76008 10.3799C3.82008 10.4799 2.84008 10.2799 2.12008 9.80657C1.06674 9.10657 1.06674 7.96657 2.12008 7.26657C2.83341 6.78657 3.84008 6.59324 4.78675 6.69991C4.51341 7.25991 4.36675 7.89324 4.36675 8.56657Z",
    fill: "#A4A7AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08019 10.58C8.02686 10.5733 7.96686 10.5733 7.90686 10.58C6.68019 10.54 5.7002 9.53333 5.7002 8.29333C5.70686 7.02667 6.72686 6 8.0002 6C9.26686 6 10.2935 7.02667 10.2935 8.29333C10.2869 9.53333 9.31353 10.54 8.08019 10.58Z",
    fill: "#A4A7AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9132 11.9598C4.90654 12.6331 4.90654 13.7398 5.9132 14.4064C7.05987 15.1731 8.93987 15.1731 10.0865 14.4064C11.0932 13.7331 11.0932 12.6264 10.0865 11.9598C8.94654 11.1931 7.06654 11.1931 5.9132 11.9598Z",
    fill: "#A4A7AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentationPeople);
export default __webpack_public_path__ + "static/media/segmentation_people.968bc917ff66510603cfa4b814f7d668.svg";
export { ForwardRef as ReactComponent };